import { dialog } from "../../../nq-component";
import React, { useState } from "react";
import DialogWarning from "./DialogWarning";

function DialogSchedule({ handleAssign }) {
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [startTime, setStartTime] = useState("");
  const [endTime, setEndTime] = useState("");

  function _handleAssign(e) {
    e.preventDefault();

    const startDateTime = new Date(startDate + "T" + startTime + ":00");
    const endDateTime = new Date(endDate + "T" + endTime + ":00");

    if (startDateTime >= endDateTime) {
      dialog.fire({
        html: <DialogWarning message={"Invalid Date and Time"} />,
        footer: false,
      });
      return;
    }

    handleAssign(startDateTime, endDateTime);
  }

  function handleChange(value, field) {
    switch (field) {
      case "startDate":
        setStartDate(value);
        break;
      case "endDate":
        setEndDate(value);
        break;
      case "startTime":
        setStartTime(value);
        break;
      case "endTime":
        setEndTime(value);
        break;
      default:
        break;
    }
  }

  return (
    <>
      <form onSubmit={_handleAssign}>
        <div className="d-flex">
          <div className="m-4">
            <i
              className="bi bi-calendar-event fs-2 px-2 py-1 rounded"
              style={{ backgroundColor: "#F5F5F5", color: "#D18237" }}
            ></i>
          </div>
          <div className="ms-3 me-1" style={{ marginTop: "35px" }}>
            <h5 className="fw-bold" style={{ color: "#D18237" }}>
              Schedule Applicant
            </h5>
            <div className="">
              <div className="row mb-3">
                <p className="">Start Date</p>
                <input
                  type="date"
                  value={startDate}
                  onChange={(e) => handleChange(e.target.value, "startDate")}
                  className={`col-12 px-3 py-2 border rounded`}
                  min={new Date().toISOString().split("T")[0]}
                  required
                />
              </div>

              <div className="row mb-3">
                <p className="">End Date</p>
                <input
                  type="date"
                  value={endDate}
                  onChange={(e) => handleChange(e.target.value, "endDate")}
                  className={`col-12 px-3 py-2 border rounded`}
                  min={new Date().toISOString().split("T")[0]}
                  required
                />
              </div>

              <div className="row mb-3">
                <p className="">Start Time</p>
                <input
                  type="time"
                  value={startTime}
                  onChange={(e) => handleChange(e.target.value, "startTime")}
                  className={`col-12 px-3 py-2 border rounded`}
                  required
                />
              </div>

              <div className="row mb-3">
                <p className="">End Time</p>
                <input
                  type="time"
                  value={endTime}
                  onChange={(e) => handleChange(e.target.value, "endTime")}
                  className={`col-12 px-3 py-2 border rounded`}
                  required
                />
              </div>
            </div>
          </div>
        </div>
        <div className="text-center mb-3">
          <button
            className="btn"
            style={{ backgroundColor: "#e8ecf3" }}
            onClick={() => dialog.close()}
          >
            Cancel
          </button>
          <button
            type="submit"
            className="btn text-white ms-2"
            style={{ backgroundColor: "#D18237" }}
          >
            Confirm
          </button>
        </div>
      </form>
    </>
  );
}

export default DialogSchedule;
